var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace1Back(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1150.05 928.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-face-1 {\n        fill: #c3825a;\n      }\n\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 1028.99,
    cy: 647.66,
    r: 121.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 121.06,
    cy: 647.66,
    r: 121.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-1",
    d: "M121.06,526.6c-17.22,0-33.59,3.62-48.42,10.1v46.66c0,68.19,19.88,131.7,54.04,185.21,64.25-2.94,115.44-55.94,115.44-120.92s-54.2-121.06-121.06-121.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-1",
    d: "M1028.99,526.6c17.22,0,33.59,3.62,48.42,10.1v46.66c0,68.19-19.88,131.7-54.04,185.21-64.25-2.94-115.44-55.94-115.44-120.92,0-66.86,54.2-121.06,121.06-121.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M575.02,0h0c263.91,0,478.18,214.26,478.18,478.18v105.19c0,190.27-154.47,344.74-344.74,344.74h-266.87c-190.27,0-344.74-154.47-344.74-344.74v-105.19C96.85,214.26,311.11,0,575.02,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace1Back);
export default __webpack_public_path__ + "static/media/face1-back.59650fd07c0b9421a7079a59a814d680.svg";
export { ForwardRef as ReactComponent };